import {
  InboxEntry,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventMeta, WebSocketEventType } from '../WebSocketContext';

/**
 * Creates a handler for InboxEntry WebSocket messages
 *
 * @param eventEmitter - Event emitter to dispatch events to subscribers
 * @returns Handler function for InboxEntry messages
 */
export function createInboxEntryMessageHandler(eventEmitter: IEventEmitter) {
  return (
    action: WebSocketAction,
    item: InboxEntry,
    meta?: WebSocketEventMeta,
  ) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(`[InboxEntryHandler] INSERT InboxEntry ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.InboxEntry,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(`[InboxEntryHandler] MODIFY InboxEntry ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.InboxEntry,
            WebSocketEventType.MODIFY,
            item,
            meta,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(`[InboxEntryHandler] REMOVE InboxEntry ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.InboxEntry,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[InboxEntryHandler] Unknown action for InboxEntry:',
            action,
          );
      }
    } catch (error) {
      log.error('[InboxEntryHandler] Handler failed:', error);
    }
  };
}
